export const version = "bytes/5.0.5";
//# sourceMappingURL=_version.js.map